export * from './post-abteilung.component';
export * from './post-abteilung.component.module';